$(document).ready(function() {
  // Initialize select2
  $('.select2').select2();
  $('#shareModal').on('shown.bs.modal', function () {
    setTimeout(function () {
      if ($('#departments').length) {
        $('#departments').select2({
          dropdownParent: $('#shareModal')
        });
      }


    }, 300); // tunggu 300ms setelah modal tampil
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".user-option").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        const name = el.dataset.name;
        const id = el.dataset.id;

        const container = document.getElementById("selectedUsers");

        // Hindari duplikat
        if (!document.getElementById(`selected-user-${id}`)) {
          const userEl = document.createElement("div");
          userEl.id = `selected-user-${id}`;
          userEl.className = "badge bg-primary me-2 mb-2";
          userEl.innerText = name;
          container.appendChild(userEl);
        }
      });
    });
  });

  // AJAX request on clicking token button
  if ($('.b-token').length > 0) {
    $('.b-token').on('click', function() {
      $.ajax({
        url: ('/tokens/sign_in'),
        type: 'get',
        data: {
          email: $('#user_intool_email').val()
        },
        beforeSend: function(xhr) {
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        }
      });
    })
  };

  

  // Menjalankan toggleFields saat halaman dimuat
  toggleFields();

  // Fungsi untuk menampilkan atau menyembunyikan kolom berdasarkan pilihan 'file_type'
  function toggleFields() {
    var fileType = $('#file_type_select').val();

    if (fileType === 'url') {
      $('#url_field').show();
      $('#file_upload_field').hide();
    } else if (fileType === 'upload') {
      $('#url_field').hide();
      $('#file_upload_field').show();
    } else {
      $('#url_field').hide();
      $('#file_upload_field').hide();
    }
  }

  $(document).on("click", ".btn-share", function(e) {
    e.preventDefault();

    const fileId = $(this).data("file-id");
    const fileName = $(this).data("file-name");

    $("#modal-file-name").text(fileName);
    $("#shareModal").attr("data-file-id", fileId);

    $("#selected-access").html('<i class="fas fa-lock me-2"></i> Restricted');
    $("#access-level-value").val("restricted");

    $.ajax({
      url: `/file_managements/${fileId}/share_access`,
      type: "GET",
      data: { mode: "restricted" },
      success: function(response) {
        $("#access-extra-form").html(response);
      },
      error: function() {
        alert("Gagal memuat akses awal.");
      }
    });

    const modal = new bootstrap.Modal(document.getElementById("shareModal"));
    modal.show();
  });

  $(document).on("click", ".access-option", function(e) {
    e.preventDefault();

    const mode = $(this).data("mode");
    const value = $(this).data("value");
    const fileId = $("#shareModal").data("file-id");

    $("#selected-access").html($(this).html());
    $("#access-level-value").val(value);

    $.ajax({
      url: `/file_managements/${fileId}/share_access`,
      type: "GET",
      data: { mode: mode },
      success: function(response) {
        $("#access-extra-form").html(response);
      },
      error: function() {
        alert("Gagal memuat akses tambahan.");
      }
    });
  });

  // Copy link button
    function showToast(message, isError = false) {
    const toast = document.getElementById('custom-toast');
    
    // Hapus konten sebelumnya
    toast.textContent = ''; 

    // Membuat elemen pesan
    const messageElement = document.createElement('span');
    messageElement.textContent = message;
    toast.appendChild(messageElement);

    // Membuat elemen tombol Batalkan
    const cancelButton = document.createElement('span');
    cancelButton.textContent = 'Batalkan';
    cancelButton.classList.add('cancel-btn');
    cancelButton.addEventListener('click', function() {
      toast.classList.remove('show'); 
    });

    // Tambahkan tombol Batalkan hanya sekali
    if (!toast.contains(cancelButton)) {
      toast.appendChild(cancelButton);
    }

    // Set background color
    toast.style.backgroundColor = isError ? '#dc3545' : 'rgba(43, 43, 43, 0.8)'; // Merah untuk error, abu tua untuk sukses

    toast.classList.add('show');

    // Hapus toast setelah 3 detik
    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  }

  $('.copy-btn').on('click', function () {
    var text = $(this).attr('data-clipboard-text');
    if (text) {
      navigator.clipboard.writeText(text).then(function () {
        showToast('Link berhasil disalin');
      }, function (err) {
        showToast('Gagal menyalin link', true);
      });
    }
  });

  // share_file_management: user dropdown behavior
  document.addEventListener("DOMContentLoaded", function () {
    const userDropdownList = document.getElementById("userDropdownList");
    const selectedUsersContainer = document.getElementById("selectedUsers");
    const dropdownLabel = document.getElementById("dropdown-label");
    const selectedUserIds = new Set();

    userDropdownList.addEventListener("click", function (event) {
      event.preventDefault();
      const target = event.target.closest("a[data-user-id]");
      if (!target) return;

      const userId = target.dataset.userId;
      const userName = target.dataset.userName;

      if (selectedUserIds.has(userId)) return;
      selectedUserIds.add(userId);

      // Update label saat user pertama dipilih
      if (selectedUserIds.size === 1) {
        dropdownLabel.textContent = userName;
      }

      const userRow = document.createElement("div");
      userRow.className = "selected-user-item d-flex justify-content-between align-items-center mb-1";
      userRow.dataset.userId = userId;
      userRow.innerHTML =` 
        <input type="hidden" name="shared_user_ids[]" value="${userId}">
        <span>${userName}</span>
        <button type="button" class="btn btn-sm btn-danger remove-user-btn">Remove</button>
      `;

      selectedUsersContainer.appendChild(userRow);
    });

    selectedUsersContainer.addEventListener("click", function (event) {
      if (event.target.classList.contains("remove-user-btn")) {
        const row = event.target.closest(".selected-user-item");
        const userId = row.dataset.userId;
        selectedUserIds.delete(userId);
        row.remove();

        // Balikin label ke default kalau semua user dihapus
        if (selectedUserIds.size === 0) {
          dropdownLabel.textContent = "Pilih user...";
        }
      }
    });
  });


  // Confirmation dialog for deletion
  if ($(".btn-delete").length > 0) {
    $(".btn-delete").on("click", function() {
      var dataId = $(this).data("id");
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          $("#feature-" + dataId + ", #voucher-" + dataId + ", #blog-" + dataId + ", #event-" + dataId + ", #category-" + dataId + ", #support-question-" + dataId).trigger("click");

          Swal.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          )
        }
      })
    })
  }

  //delete buat file management
    $(".btn-delete-file").on("click", function() {
      var dataId = $(this).data("id");

      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          var form = $("#file-management-" + dataId);
          if (form.length > 0) {
            form.submit();
          } else {
            console.error("Form not found for ID: " + dataId);
          }
        }
      });
    });

    //share file management
    $(document).on("click", ".btn-share", function() {
      $("#shareModal").modal('show');
    });


  if($('.modal-show').length > 0){
    $('.modal-show').on('click', function(){
      elmID = $(this).data('target');
      $("#" + elmID).modal('show');
    });

    $('.modal-dismiss').on('click', function(){
      elmID = $(this).data('target');
      $("#" + elmID).modal('hide');
    })
  }

  if($('#company_code').length > 0){
    $('#company_code').change(function(){
      if($('#company_code').val().length > 0){
        front_token = generateRandomText(6);
        back_token = generateRandomText(6);
        token = (front_token + $('#company_code').val() + back_token);
        $('#company_auth_token').val(token);
        $('#auth_token_text').val(token);
      }else{
        $('#company_auth_token').val('');
        $('#auth_token_text').val('');
      }
    })
  }
  

  // Add new speaker form box
  $('#add-speaker').click(function() {
    var index = $('.form-box').length;
    var newSpeakerForm = $('.form-box').first().clone();
    newSpeakerForm.attr('id', 'form-box-' + index);
    newSpeakerForm.find(':input').each(function() {
      $(this).val('');
    });
    $('#event_speaker_list').append(newSpeakerForm);
  });

  // Initialize timepicker
  $('.timepicker').datetimepicker({
    format: 'LT'
  });
  $('#timepicker1').datetimepicker({
    format: 'LT'
  });
  $('#timepicker2').datetimepicker({
    format: 'LT'
  });

  $('.date-picker').datetimepicker({
    format: 'YYYY/MM/DD'
  });
  $('#datepicker1').datetimepicker({
    format: 'YYYY/MM/DD'
  });
  $('#datepicker2').datetimepicker({
    format: 'YYYY/MM/DD'
  });

  // Handle switch status using localStorage
  var switchElement = $('#customSwitch1');
  var switchStatus = localStorage.getItem('customSwitch1');
  if (switchStatus !== null) {
    switchElement.prop('checked', switchStatus === 'on');
  }

  // Update Switch Status
  function updateSwitchStatus() {
    localStorage.setItem('customSwitch1', switchElement.prop('checked') ? 'on' : 'off');
  }
  switchElement.on('change', updateSwitchStatus);

  // Sorting functionality
  if ($('.sorting').length > 0) {
    $('.sorting').click(function() {
      var current_class = $(this).attr("class");
      var current_data_id = $(this).attr("data-id");
      var current_id = $(this).attr("id");

      if (current_class == "data-sort sorting") {
        new_class = "data-sort sorting_asc";
        current_data_id += "-desc"
      } else if (current_class == "data-sort sorting_asc") {
        new_class = "data-sort sorting_desc";
        current_data_id += "-asc"
      } else if (current_class == "data-sort sorting_desc") {
        new_class = "data-sort sorting_asc";
        current_data_id += "-desc"
      }

      $(".data-sort").each(function() {
        $(this).attr("class", "data-sort sorting");
      });

      $("#" + current_id).attr("class", new_class);

      $("#last_sort").val(current_data_id);

      reload_list({
        sort: current_data_id,
        per_page: $("#table-data-show").val(),
        page: $("#page").val(),
        search: $('#search-box-table').val(),
        format: 'js'
      });
    });
  };

  //Pagination handling
  set_paginate();

  // Move onchange attribute inside $(document).ready function
  $('.custom-file-input').on('change', function() {
    var fileName = $(this).val().split('\\').pop();
    if(fileName != ""){
      $(this).next('.custom-file-label').html(fileName);
    }else{
      $(this).val('');
      $(this).next('.custom-file-label').html('Choose file');
    }
  });


});

//Move set_paginate and reload_list outside $(document).ready()
window.set_paginate = function() {
  $('.page-link').click(function() {
    var page = $(this).attr("data-id");
    reload_list({
      page: page,
      per_page: $("#table-data-show").val(),
      sort: $("#last_sort").val(),
      search: $('#search-box-table').val(),
      format: 'js'
    });
    $("#page").val(page);
  });

  $("#table-data-show").on('change', function() {
    var page = $("#page").val();
    reload_list({
      page: page,
      per_page: $("#table-data-show").val(),
      sort: $("#last_sort").val(),
      search: $('#search-box-table').val(),
      format: 'js'
    });
  })
}

window.reload_list = function(params) {
  $.ajax({
    url: $("#intools-app").data('url'),
    method: "get",
    data: params,
    dataType: "script"
  })
}


window.generateRandomText = function(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}





